$(document).ready(() => {

	checkChatScreen();

	let CURRENT_LOGGED_USER_ID = "current_logged_user_id";

	function checkChatScreen(){
		let pathname = window.location.pathname;
		if(pathname.includes("/order_payment") || pathname.includes("/subscription_payment")) {
			let current_order = $("#current_order_channel").val();
			if (current_order != null && current_order != ""){
				openChannelChat(current_order);
			}
		}
	}

	function openChannelChat(current_order){
		(function() {
			this.App || (this.App = {});
			App.cable = ActionCable.createConsumer();
		}).call(this);
		
		App.room = App.cable.subscriptions.create(
		{
			channel: ("OrderChannel"),
			order_id: current_order
		},
		{
			connected: function() {},
			disconnected: function() {},
			received: function(data) {
				if(data.action == "payment-done"){
					paymentConfirmed(data);
				} else if(data.action == "pix-due-date"){
					hideElement("current-payment", true);
					hideElement("new-payment", false);
				}
			},
			speak: function(current_order) {
				this.perform('speak', {
					order_id: current_order
				});
			}
		});
	}

	function paymentConfirmed(data){
		if(data != null && data.redirect != null){
			alert("Pagamento realizado com sucesso!");
			window.location = data.redirect;
		}
	}

	// setInterval(function () {
	// 	if(App.room){
	// 		let current_order = $("#current_order_channel").val();
	// 		App.room.speak(current_order);
	// 	}
	// }, 60000);

});